var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7346 19.4125L38.3919 4.60001H35.3925L24.4022 17.4615L15.6243 4.60001H5.5L18.7739 24.0489L5.5 39.582H8.49954L20.1056 25.9999L29.3757 39.582H39.5L25.7339 19.4125H25.7346ZM21.6263 24.2202L20.2814 22.2835L9.58031 6.87328H14.1874L22.8233 19.3098L24.1683 21.2465L35.3939 37.4122H30.7868L21.6263 24.2209V24.2202Z",
    fill: "#C7C7C7"
  })));
};
export default SvgX;